
import { defineComponent } from 'vue';
import IconGlobe from "@/components/icons/IconGlobe.vue";
import CubeList from "@/components/CubeList.vue";
import CountryList from "@/components/CountryList.vue";

export default defineComponent({
  name: 'CountrySeminarsSection',
  components: {
    IconGlobe,
    CubeList,
    CountryList
  }
});
